import { SkeletonLoader } from '@kanda-libs/ks-design-library';
import { AddBankDetails, Description, Icon, Status } from './components';

export interface JobFinanceApplicationProgressCardProps {
  isLoading?: boolean;
}

const JobFinanceApplicationProgressCard: React.FunctionComponent<JobFinanceApplicationProgressCardProps> =
  function ({ isLoading = false }) {
    return (
      <SkeletonLoader
        isLoading={isLoading}
        count={3}
        afterLoading={
          <div className="flex flex-col">
            <Icon />
            <Description />
            <Status />
            <AddBankDetails />
          </div>
        }
      />
    );
  };

export default JobFinanceApplicationProgressCard;
